import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum WorkBuddyConnectSecurityRight {
    CanAccess = 62000
}

export class WorkBuddyConnectSecurityModule extends BaseSecurityModule<WorkBuddyConnectSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.WorkBuddyConnect,
            [
                { _id: WorkBuddyConnectSecurityRight.CanAccess, name: 'Access', basic: true },
            ] as SecurityRight<WorkBuddyConnectSecurityRight>[]
        );

        this.plan = TenantSubscription.Custom;
    }


}